import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 30,
  }
});

const SvgProgressPrimarySymbol = () => {
  const classes = useStyles();

  return (
  <svg
    className={classes.svg}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 95.451 102.068"
  >
    <path
      d="M95.452 28.995 95.45 79.96c0 1.128-.798 2.51-1.776 3.073l-1.665.965-12.7 7.33-8.579 4.953-1.775 1.025V42.241L21.272 14.71l22.65-13.074L45.995.441c.975-.564 2.576-.564 3.552 0l31.42 18.14 14.486 8.364zM58.35 48.355l-9.78-5.648-22.877-13.209c-.976-.566-2.572-.566-3.55 0L1.85 41.214h-.002L.073 42.239l34.442 19.886.004 39.77 20.274-11.708 1.78-1.03c.978-.565 1.778-1.948 1.778-3.077l-.002-35.673zM.073 82.011l23.83 13.765V68.239z"
      style={{
        fill: "#5ce500",
      }}
    />
  </svg>
  );
};

const ProgressLogoIcon = SvgProgressPrimarySymbol;
export default ProgressLogoIcon;

